import styles from './styles.less';
import PropTypes from 'prop-types';
import React from 'react';

const PicabooLink = (props) => {
  const cssClass = props.cssClass || styles.defaultLink;
  return (
    <a className={cssClass} onClick={props.onClick}>
      {props.linkText}
    </a>
  );
};

PicabooLink.propTypes = {
  onClick: PropTypes.func,
  linkText: PropTypes.string.isRequired,
  cssClass: PropTypes.string,
};

export default PicabooLink;
